module.exports = __webpack_public_path__ + "static/img/ss03@2x.9ea7511b.png";